import React, {useEffect, useRef, useState} from "react";
import './styles/Content.scss';
import {withRouter} from "react-router";
import {RouteComponentProps} from "react-router-dom";
import {ColorPromotionText} from "../utils/ColorPromotionText";
import {BrandA} from "../ui/buttons/buttons";
import { setModalPath } from "../onboardingpage/modalview/utils";
import { PATH } from "../onboardingpage/modalview/UserModalController";
import { useSelector } from "react-redux";
import { AppState } from "../RootReducer";

interface Props extends RouteComponentProps{
    loggedIn: boolean
    content1?: string
    content2?: string
    buttonTitle: string;
    position?: string | undefined;
    signupForm?: boolean | undefined;
    pathPush?: string;
}

const Content: React.FC<Props> = ({loggedIn, content1, content2, buttonTitle, history, position, signupForm, pathPush}) => {
    const titleText = useRef<HTMLDivElement>(null);
    const titleText2 = useRef<HTMLDivElement>(null);
    const userModal = useSelector((app: AppState) => app.user.modal)
    ColorPromotionText(content1, titleText.current, "colorText")
    ColorPromotionText(content2, titleText2.current, "colorText")
    let className:string;
    let classNameSignup:string;
    let classNameButtonWrap:string;

    const x = window.matchMedia("(max-width: 992px)")
    const [mediaMatches, setMediaMatches] = useState(x.matches);
    useEffect(() => {
        x.addListener(isMatched)
        return () => {
            x.removeListener(isMatched);
        };
    }, [mediaMatches]);

    const isMatched = (x: any) => {
        setMediaMatches(x.matches)
    }

    if (position === 'left' && signupForm && !mediaMatches) {
        className = "contentWrap twoColumns left textAlignLeft";
        classNameButtonWrap = "buttonWrap content-hide";
    } else if (position === 'right' && signupForm && !mediaMatches) {
        className = "contentWrap twoColumns right textAlignLeft";
        classNameButtonWrap = "buttonWrap content-hide";
    } else if (position && !signupForm) {
        className = "contentWrap twoColumns";
        classNameButtonWrap = "buttonWrap content-show buttonLeft";
    } else {
        className = "contentWrap fullWidth";
        classNameButtonWrap = "buttonWrap content-show";
    }
    return (
        <React.Fragment>
            <div className={`${className} ContentComponent`}>
                {
                    content1&& (<h1 ref={titleText} className={"content content1"}/>)
                }
                {
                    content2&& (<h2 ref={titleText2} className={"content content2"}/>)
                }

                <div className={"ButtonContainer"}>
                    <div className={classNameButtonWrap}>
                        {!loggedIn && <BrandA className={"btn btn-cta register-link"} onClick={() => {setModalPath({path: {type: PATH.REGISTRATION, modal: PATH.MODAL_TYPE}, history: history, options: userModal})}}>
                            {buttonTitle}
                        </BrandA>}
                    </div>
                </div>
            </div>
        </React.Fragment>
    )
}

export default withRouter<Props,any>(Content);